<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Custom Keg Monitor</ion-title>
  </ion-toolbar>
</ion-header>
@if (items$ | async; as items) {
  <ion-content>
    <ion-card class="ion-no-padding">
      <ion-card-content class="ion-no-padding">
        <ion-list lines="full" class="ion-no-padding">
          @for (item of items; track item; let i = $index) {
            <ion-item
              (click)="selectItem(item)" button
              routerLinkActive="router-link-active">
              <ion-label>
                {{item.name}}
              </ion-label>
              @if (item.tap?.name) {
                <ion-label slot="end">
                  <ion-icon src="/assets/icons/flat/beer/tap.svg" >
                  </ion-icon>
                  {{item.tap?.name}}
                </ion-label>
              }
            </ion-item>
          }
        </ion-list>
      </ion-card-content>
    </ion-card>
  </ion-content>
}
